import {Component} from '@angular/core';
import {PrimeNgImportsModule} from '../../../../sdk/src/prime-ng-imports';
import {IBasePageComponent} from '../../../../sdk/src/components/ibase-page/ibase-page.component';
import {ServiceRequestGroupCRUDComponent} from '../../components/service-request/service-request-group-crud/service-request-group-crud.component';

@Component({
    selector: 'app-cg-instances-page',
    templateUrl: './cg-instances-page.component.html',
    imports: [PrimeNgImportsModule, ServiceRequestGroupCRUDComponent]
})
export class CGInstancesPageComponent extends IBasePageComponent {
    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
